export default "__VITE_ASSET__BVxF$mDl__"